export { default as Details } from './Details';
export { default as Review } from './Review';
export { default as DataHx } from './DataHx';
